import { scrollBarStyle } from '@/constants';

export const dropdownFormStyle = (darkMode) => ({
    dropdownIndicator: (provided, { selectProps }) => ({
        ...provided,
        bg: 'transparent',
        px: 2,
        cursor: 'pointer',
        '> svg': {
            transform: `rotate(${selectProps.menuIsOpen ? -180 : 0}deg)`,
            transitionDuration: '.4s',
        },
    }),
    container: (provided) => ({
        ...provided,
        height: '30px',
    }),
    indicatorSeparator: (provided) => ({
        ...provided,
        display: 'none',
    }),
    option: (provided, { isFocused }) => ({
        ...provided,
        backgroundColor:
            darkMode && isFocused
                ? 'rgba(255, 255, 255, 0.16)!important'
                : null,
        overflow: 'visible',
        position: 'relative',
    }),
    control: (provided, state) => ({
        ...provided,
        background: `${darkMode ? 'dark.bgDark' : '#fff'}`,
        minHeight: '30px',
        height: '30px',
        boxShadow: state.isFocused ? null : null,
        color: `${darkMode ? 'dark.textDark' : 'inherit'}`,
        borderColor: `${darkMode ? 'dark.tcap-borderGray' : 'inherit'}`,
    }),
    valueContainer: (provided) => ({
        ...provided,
        height: '30px',
        padding: '0 6px',
        background: `${darkMode ? 'dark.bgDark' : 'inherit'}`,
    }),
    input: (provided) => ({
        ...provided,
        height: '30px',
        margin: '0px',
    }),
    indicatorsContainer: (provided) => ({
        ...provided,
        height: '30px',
        background: `${darkMode ? 'dark.bgDark' : 'inherit'}`,
    }),
    inputContainer: (provided) => ({
        ...provided,
        background: `${darkMode ? 'dark.bgDark' : 'inherit'}`,
        color: `${darkMode ? 'dark.textDark' : 'inherit'}`,
    }),
    menuList: (provided, { selectProps }) => ({
        ...provided,
        ...scrollBarStyle(darkMode),
        background: `${
            darkMode && selectProps.onFocus ? 'dark.tcap-weak' : 'white'
        }`,
        borderColor: `${darkMode ? 'dark.tcap-borderGray' : 'inherit'}`,
        color: `${darkMode ? 'white' : 'black'}`,
        zIndex: 1001,
    }),
    menu: (provided) => ({
        ...provided,
        zIndex: 1001,
        overflow: 'visible',
    }),
});
